export function UserAgreement() {
  const pClasses = "mb-4 text-justify text-gray-700";
  const ulClasses = "mb-4 list-disc pl-6 space-y-2";
  return (
    <div>
      <h1 className="text-center text-3xl font-bold text-[#2c3e50] mb-8">
        匹配与决策智能体引擎系统用户协议
      </h1>
      <h2 className="text-2xl font-semibold text-[#34495e] mt-8 pb-2 border-b-2 border-blue-500">
        1. 服务内容
      </h2>
      <p className={pClasses}>
        1.1
        匹配与决策智能体引擎系统（以下简称"我们"）是人工智能训练与服务平台，提供AI模型服务、智能对话、内容生成、API接口等相关服务。
      </p>
      <p className={pClasses}>
        1.2
        匹配与决策智能体引擎系统旨在为用户提供智能问答、内容生成、信息查询、创意激发等服务。用户通过输入文本、语音、图片等方式与AI助手进行交互，获得相应的智能回复。
      </p>
      <p className={pClasses}>
        1.3
        匹配与决策智能体引擎系统可能会根据用户输入生成文字内容、代码、图片描述等。这些生成内容仅供用户参考，用户应自行判断其准确性、完整性和适用性。
      </p>
      <p className={pClasses}>
        1.4
        我们不断优化和完善服务内容，可能会更新服务功能、调整服务策略、升级技术架构，以提供更好的用户体验。
      </p>
      <h2 className="text-2xl font-semibold text-[#34495e] mt-8 pb-2 border-b-2 border-blue-500">
        2. 账号管理
      </h2>
      <p className={pClasses}>
        2.1
        用户在使用達達服务前，需要注册并登录账号。用户注册时应提供真实、准确、完整的个人资料，并在资料变更时及时更新。
      </p>
      <p className={pClasses}>
        2.2
        用户应妥善保管账号和密码，不得将账号转让、出售或出借给他人使用。如发现账号被他人非法使用，应立即通知我们。
      </p>
      <p className={pClasses}>
        2.3
        用户有权选择注销账号。账号注销后，我们将停止为用户提供服务，并根据相关法律法规的要求处理用户数据。
      </p>
      <p className={pClasses}>
        2.4
        我们有权根据法律法规的要求、服务协议的约定或其他合理理由，对用户账号进行冻结、限制或注销。
      </p>
      <p className={pClasses}>
        2.5
        您在注册账号时，应确认您已年满18周岁，具备完全民事行为能力。如您不具备完全民事行为能力，请在监护人的指导下使用我们的服务。
      </p>
      <h2 className="text-2xl font-semibold text-[#34495e] mt-8 pb-2 border-b-2 border-blue-500">
        3. 使用规范
      </h2>
      <p className={pClasses}>
        3.1
        用户在使用達達服务时，应遵守中华人民共和国相关法律法规，尊重社会公德和公序良俗，不得利用達達服务从事违法违规活动。
      </p>
      <p className={pClasses}>3.2 用户在使用達達服务时，不得进行以下行为：</p>
      <ul className={ulClasses}>
        <li className="mb-2 text-justify">
          发布、传播含有虚假、诈骗、赌博、暴力、色情、恐怖等违法违规信息；
        </li>
        <li className="mb-2 text-justify">
          侵犯他人知识产权、名誉权、隐私权等合法权益；
        </li>
        <li className="mb-2 text-justify">
          干扰達達服务的正常运行，如通过恶意程序、病毒等方式攻击服务系统；
        </li>
        <li className="mb-2 text-justify">
          尝试破解、入侵達達服务系统或获取未授权的数据；
        </li>
        <li className="mb-2 text-justify">
          滥用服务，如大量发送垃圾信息、恶意占用系统资源等；
        </li>
        <li className="mb-2 text-justify">
          其他违反法律法规或损害我们及其他用户合法权益的行为。
        </li>
      </ul>
      <p className={pClasses}>
        3.3
        用户应确保其输入内容和使用方式符合法律法规和本协议的规定。如用户输入内容违反规定，我们有权拒绝提供服务或采取其他必要措施。
      </p>
      <p className={pClasses}>
        3.4
        用户应自行承担因使用達達服务而产生的风险和后果。我们不对用户因使用服务而遭受的任何损失承担责任，除非该损失是由我们的故意或重大过失造成的。
      </p>
      <p className={pClasses}>
        3.5
        对于用户通过達達服务生成的内容，用户应自行负责审核、判断和使用，确保不侵犯他人权益且符合法律法规要求。
      </p>
      <h2 className="text-2xl font-semibold text-[#34495e] mt-8 pb-2 border-b-2 border-blue-500">
        4. 知识产权
      </h2>
      <p className={pClasses}>
        4.1
        我们对達達服务及其相关内容（包括但不限于软件、代码、文本、图片、音频、视频等）拥有知识产权。未经我们明确书面许可，用户不得以任何形式复制、修改、传播、销售、出租、许可他人使用或进行其他商业利用。
      </p>
      <p className={pClasses}>
        4.2
        用户通过達達服务生成的内容，知识产权归用户所有，但用户应确保其对生成内容的使用不违反法律法规和本协议的规定。
      </p>
      <p className={pClasses}>
        4.3
        用户在使用達達物流服务时，授权我们使用、存储、处理其输入内容和生成内容，用于服务优化、模型训练等目的，但我们会对用户数据进行匿名化和去标识化处理。
      </p>
      <h2 className="text-2xl font-semibold text-[#34495e] mt-8 pb-2 border-b-2 border-blue-500">
        5. 隐私保护
      </h2>
      <p className={pClasses}>
        5.1
        我们重视用户隐私保护，将按照《達達隐私政策》的规定收集、使用、存储和保护用户个人信息。
      </p>
      <p className={pClasses}>
        5.2
        用户在使用達達服务时，应同意我们按照隐私政策的规定处理其个人信息。如用户不同意隐私政策，应立即停止使用服务。
      </p>
      <p className={pClasses}>
        5.3
        我们采取多种安全措施保护用户个人信息，包括但不限于加密技术、访问控制、安全审计等，但互联网环境并非绝对安全，我们无法完全保证用户信息的安全。
      </p>
      <h2 className="text-2xl font-semibold text-[#34495e] mt-8 pb-2 border-b-2 border-blue-500">
        6. 服务变更与中断
      </h2>
      <p className={pClasses}>
        6.1
        我们有权根据业务发展需要，变更、暂停或终止部分或全部服务，但应提前通知用户（除非因不可抗力或紧急情况导致无法提前通知）。
      </p>
      <p className={pClasses}>
        6.2 因以下原因导致服务中断或终止的，我们不承担责任：
      </p>
      <ul className={ulClasses}>
        <li className="mb-2 text-justify">自然灾害、战争等不可抗力因素；</li>
        <li className="mb-2 text-justify">
          黑客攻击、网络故障、服务器故障等技术原因；
        </li>
        <li className="mb-2 text-justify">用户违反法律法规或本协议的规定；</li>
        <li className="mb-2 text-justify">
          其他非我们原因导致的服务中断或终止。
        </li>
      </ul>
      <p className={pClasses}>
        6.3
        如我们终止服务，应按照相关法律法规的要求处理用户数据，并尽可能为用户提供数据导出等便利。
      </p>
      <h2 className="text-2xl font-semibold text-[#34495e] mt-8 pb-2 border-b-2 border-blue-500">
        7. 免责声明
      </h2>
      <p className={pClasses}>
        7.1
        達達服务仅供用户参考和使用，我们不对服务内容的准确性、完整性、适用性、及时性等作出任何保证。
      </p>
      <p className={pClasses}>
        7.2
        用户应自行承担因使用達達服务而产生的风险和后果。我们不对用户因使用服务而遭受的任何直接、间接、偶然、特殊或后续损失承担责任。
      </p>
      <p className={pClasses}>
        7.3
        我们不对第三方通过達達服务提供的内容或服务承担责任。用户与第三方之间的纠纷应自行解决。
      </p>
      <p className={pClasses}>
        7.4
        如因用户违反法律法规或本协议的规定，导致我们遭受损失（包括但不限于直接经济损失、商誉损失等），用户应承担赔偿责任。
      </p>
      <h2 className="text-2xl font-semibold text-[#34495e] mt-8 pb-2 border-b-2 border-blue-500">
        8. 协议更新
      </h2>
      <p className={pClasses}>
        8.1 我们有权根据法律法规的更新、业务的发展等因素，对本协议进行更新。
      </p>
      <p className={pClasses}>
        8.2
        当本协议发生变更时，我们会在達達物流平台显著位置公示变更内容，并通过适当方式通知用户。
      </p>
      <p className={pClasses}>
        8.3
        如用户继续使用達達物流服务，视为同意更新后的协议。如用户不同意更新后的协议，应立即停止使用服务。
      </p>
      <h2 className="text-2xl font-semibold text-[#34495e] mt-8 pb-2 border-b-2 border-blue-500">
        9. 法律适用与管辖
      </h2>
      <p className={pClasses}>
        9.1 本协议的签订、履行、解释及争议解决均适用中华人民共和国法律。
      </p>
      <p className={pClasses}>
        9.2
        如用户与我们之间因本协议发生争议，应首先通过友好协商解决；协商不成的，任何一方均有权向有管辖权的人民法院提起诉讼。
      </p>
      <h2 className="text-2xl font-semibold text-[#34495e] mt-8 pb-2 border-b-2 border-blue-500">
        10. 其他
      </h2>
      <p className={pClasses}>
        10.1
        本协议构成用户与我们之间关于使用達達物流服务的完整协议，取代之前的任何口头或书面约定。
      </p>
      <p className={pClasses}>
        10.2 如本协议中的任何条款因违反法律法规而无效，不影响其他条款的效力。
      </p>
      <p className={pClasses}>
        10.3 如您对本协议有任何疑问或建议，请通过以下方式联系我们：
      </p>
      <p className={pClasses}>
        公司地址：中国(四川）自由贸易试验区天府新区兴隆街道湖畔路东段733号1栋3楼
      </p>
    </div>
  );
}
